import { compose } from 'redux'
import { withRouter } from 'react-router-dom'

import { ForgotPasswordPage as component } from './component'

import { ForgotPasswordPageOwnProps } from './types'

export const ForgotPasswordPage =
  compose<React.ComponentType<ForgotPasswordPageOwnProps>>(withRouter)(component)
